module.exports = __webpack_public_path__ + "img/services-icon.c18c8ca6.png";